<template>
  <div class="profiling-mini__content" ref="profilingSurvey" :class="{ 'profiling-mini__content_hidden': hidden }">
    <div class="profiling-mini__content-head" @click="$emit('toggle', !hidden)">
      <div class="profiling-mini__content-title">Оцените, насколько вы готовы рекомендовать мероприятие&nbsp;коллегам?
      </div>
      <div class="profiling-mini__content-arrow">
        <div class="profiling-mini__content-arrow-icon">
          <svg width="19" height="11" viewBox="0 0 19 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 9.25L9.5 1.75L17 9.25" stroke="white" stroke-width="1.5" stroke-linecap="square" />
          </svg>
        </div>
      </div>
    </div>

    <div class="profiling-mini__content-body" v-if="!hidden">
      <div class="profiling-mini__survey-question">
        <div class="profiling-mini__question-answers">

          <div class="profiling-mini__question-radios">
            <div class="profiling-mini__question-radio" v-for="(answer) in 10" :key="answer">
              <input type="radio" :id="`radio_${answer}`" v-model="answerResult" :value="answer" />
              <div class="profiling-mini__question-radio-container">
                <label :for="`radio_${answer}`" class="profiling-mini__question-label" v-html="answer"></label>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="profiling-mini__buttons mt-4 mb-4">
        <div class="button button_pink d-inline-flex mx-auto" @click="surveyAnswerSend()" :class="{
          button_disabled:
            !answerResult,
        }">
          Отправить
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProfilingModal",
  props: {
    hidden: Boolean,
    eventId: Number,
  },
  data: () => ({
    answerResult: null,
  }),
  computed: {},
  methods: {
    surveyAnswerSend() {
      return this.$axios({
        url: `/api/event/${this.eventId}/feedback/`,
        method: "POST",
        data: {
          estimation: this.answerResult
        },
      })
        .then((res) => {
          this.$emit('remove')
        })
        .catch((error) => {

        });
    },

  },
  created() {

  },
};
</script>

<style lang="scss" scoped>
.profiling-mini {
  &__content {
    position: fixed;
    bottom: 30px;
    left: 50%;
    width: 600px;
    transform: translateX(-50%);
    max-width: 95vw;
    border: 1px solid #ebefee;
    border-radius: 8px;
    background-color: #fff;
    z-index: 1000;

    @media screen and (max-width: 767px) {
      width: 90%;
      bottom: 10px;
    }

    &_hidden {
      & .profiling-mini__content-arrow-icon {
        transform: rotate(0);
      }

      & .profiling-mini__content-head {
        border-radius: 8px;
      }
    }

    &-head {
      border-radius: 8px 8px 0 0;
      background-color: #d0006f;
      display: flex;
      justify-content: flex-start;
      align-items: stretch;
      overflow: hidden;
    }

    &-arrow {
      cursor: pointer;
      margin-left: auto;
      width: 35px;
      flex-shrink: 0;
      background-color: #830051;
      display: flex;
      justify-content: center;
      align-items: center;

      &-icon {
        transform: rotate(180deg);
      }
    }

    &-title {
      padding: 16px;
      font-family: "Roboto", sans-serif;
      font-size: 16px;
      font-weight: 400;
      line-height: 18px;
      color: #fff;
      text-align: center;

      @media screen and (max-width: 767px) {
        flex-direction: column;
      }
    }

    &-questions-count {
      margin-left: auto;
      font-family: "Roboto Slab", sans-serif;
      font-size: 18px;
      font-weight: 400;
      line-height: 22px;
      text-align: left;
      color: #1f1f1f;

      @media screen and (max-width: 767px) {
        margin: 8px auto 0;
      }
    }

    &-body {
      display: flex;
      flex-direction: column;
    }
  }

  &__question-title {
    font-family: "Roboto Slab", sans-serif;
    font-size: 23px;
    font-weight: 400;
    line-height: 29px;
    color: #1f1f1f;
    margin-bottom: 32px;
  }

  &__question-checkbox {
    padding: 16px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    position: relative;
    cursor: pointer;
    border: 1px solid #ebefee;

    &:last-child {
      margin-bottom: 0;
    }

    &:hover {
      .profiling-mini {
        &__question-checkbox {
          &-correct {
            background-color: #830051;
          }
        }
      }
    }

    & input {
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      width: 100%;
      height: 100%;
      border: 0;
      padding: 0;
      margin: 0;
      z-index: 2;
      cursor: pointer;

      &:checked {
        &~.profiling-mini {
          &__question-checkbox-container {
            &>.profiling-mini {
              &__question-checkbox {
                &-correct {
                  background-color: #830051;

                  &>* {
                    opacity: 1;
                  }
                }
              }
            }
          }

          &__question-label {
            color: #830051;
          }
        }
      }
    }

    &-container {
      width: 18px;
      height: 18px;
      flex-shrink: 0;
      margin-right: 8px;
    }

    &-correct {
      display: flex;
      justify-content: center;
      align-items: center;
      border: 2px solid #830051;
      border-radius: 4px;
      transition: 0.3s;
      background-color: transparent;
      width: 100%;
      height: 100%;

      &>* {
        opacity: 0;
        flex-shrink: 0;
      }
    }
  }

  &__question-answers {
    padding: 0 32px;
    margin-top: 16px;
  }

  &__question-radio {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    position: relative;
    cursor: pointer;


    & input {
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      width: 100%;
      height: 100%;
      border: 0;
      padding: 0;
      margin: 0;
      z-index: 2;
      cursor: pointer;

      &:checked {
        &~.profiling-mini {
          &__question-radio-container {
            background-color: #FAFCE9;
          }

        }
      }
    }

    &-container {
      width: 40px;
      height: 40px;
      flex-shrink: 0;
      border: 1px solid #E5E5E5;
      border-radius: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  &__question-label {
    margin: auto 0;
    font-family: "Roboto", sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    color: #3c4242;
    cursor: pointer;
  }

  &__question-radios {
    display: grid;
    grid-template-columns: repeat(10, 1fr);
    gap: 16px;

    @media screen and (max-width: 767px) {
      grid-template-columns: repeat(5, 1fr);
    }
  }

  &__survey-result {
    display: flex;
    flex-direction: column;
    height: 100%;

    .profiling-mini {
      &__question-checkbox {
        pointer-events: none;

        &_correct {
          &>.profiling-mini {
            &__question-checkbox-container {
              &>.profiling-mini {
                &__question-checkbox {
                  &-correct {
                    background-color: #830051;

                    &>* {
                      opacity: 1;
                    }
                  }
                }
              }
            }

            &__question-label {
              color: #830051;
            }
          }
        }

        &_incorrect {
          &>.profiling-mini {
            &__question-checkbox-container {
              &>.profiling-mini {
                &__question-checkbox {
                  &-correct {
                    background-color: #da338c;
                    border-color: #da338c;

                    &>* {
                      opacity: 1;
                    }
                  }
                }
              }
            }

            &__question-label {
              color: #ec99c5;
            }
          }
        }
      }

      &__question-radio {
        pointer-events: none;

        &_correct {
          &>.profiling-mini {
            &__question-radio-container {
              &>.profiling-mini {
                &__question-radio {
                  &-correct {
                    background-color: #fff;

                    &>* {
                      opacity: 1;
                    }
                  }
                }
              }
            }

            &__question-label {
              color: #830051;
            }
          }
        }

        &_incorrect {
          &>.profiling-mini {
            &__question-radio-container {
              &>.profiling-mini {
                &__question-radio {
                  &-correct {
                    background-color: #fff;
                    border-color: #f6cce2;

                    &>* {
                      opacity: 1;
                    }
                  }
                }
              }
            }

            &__question-label {
              color: #ec99c5;
            }
          }
        }
      }

      &__survey-question {
        margin-bottom: 32px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    &-title {
      margin-bottom: 32px;
      font-family: "Roboto Slab", sans-serif;
      font-size: 23px;
      font-weight: 400;
      line-height: 29px;
      text-align: center;
      color: #1f1f1f;

      @media screen and (max-width: 767px) {
        font-size: 20px;
        line-height: 24px;
      }
    }

    &-button {
      margin: 0 auto;
      width: fit-content;
      padding-left: 16px;
      padding-right: 16px;
      color: #fff;
      background-color: #6bc399;

      @media screen and (max-width: 767px) {
        width: 100%;
        max-width: 280px;
        margin: 0 auto;
        display: flex;
      }
    }
  }

  &__buttons {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
}
</style>